import React from 'react'
import ImportTransactions from '../features/import-transactions/ImportTransactions'

const ImportTransactionsPage = () => {
  return (
    <ImportTransactions/>
  )
}

export default ImportTransactionsPage
